import httpInstance from './Config'


export default function Delete(props){
    if(props.noToken){
        return httpInstance.delete(props.url, {        
            headers: {
                'Content-Type': 'application/json',
                "Accept": "application/json",
            }
        })            
    }else{
        return httpInstance.delete(props.url, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${props.access_token}`,
                "Accept": "application/json",
            }
        })
    }
    

}